'use client';

import { homeConfig } from '@/features/home/home.config';
import { useT } from 'next-i18next/client';
import type { FC } from 'react';

const PROCESS_STEPS = [
  { step: '01', titleKey: 'home:process.step_0_title', descriptionKey: 'home:process.step_0_description' },
  { step: '02', titleKey: 'home:process.step_1_title', descriptionKey: 'home:process.step_1_description' },
  { step: '03', titleKey: 'home:process.step_2_title', descriptionKey: 'home:process.step_2_description' },
  { step: '04', titleKey: 'home:process.step_3_title', descriptionKey: 'home:process.step_3_description' },
  { step: '05', titleKey: 'home:process.step_4_title', descriptionKey: 'home:process.step_4_description' },
] as const;

export const ProcessBlock: FC = () => {
  const { t } = useT(homeConfig.i18nNamespaces);

  return (
    <section className="bg-[#0A0A0A] py-24 md:py-[96px]">
      <div className="container">
        <p className="text-xs font-medium tracking-widest uppercase text-[#F24E1E]">
          {t('home:process.label')}
        </p>
        <h2 className="mt-4 text-[clamp(36px,4vw,56px)] font-medium tracking-[-0.025em] leading-[1] text-white">
          {t('home:process.title')}
        </h2>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-5">
          {PROCESS_STEPS.map((item, i) => (
            <div
              key={item.step}
              className={`border-t border-white/10 pt-6 ${i < PROCESS_STEPS.length - 1 ? 'pr-8' : ''}`}
            >
              <span className="text-xs font-mono tracking-widest text-[#F24E1E]">
                {item.step}
              </span>
              <h3 className="mt-6 text-base font-medium text-white">
                {t(item.titleKey)}
              </h3>
              <p className="mt-3 text-sm text-white/60 leading-relaxed">
                {t(item.descriptionKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
